import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { combineFilters } from "@formant/core/common/combineFilters";
import { toLegacyTagsets } from "@formant/core/common/toLegacyTagsets";
import { IScopeFilter } from "@formant/core/model/IScopeFilter";
import { ITagSets } from "@formant/core/model/ITagSets";

import { metadataStore } from "../../../stores";
import { IMultiSelectOption, MultiSelect } from "../MultiSelect";
import * as styles from "./TagSelect.scss";

export interface ITagSelectProps {
    value: string[];
    tagKey: string;
    filter: IScopeFilter;
    context?: IScopeFilter;
    className?: string;
    onChange: (key: string, value: string[]) => void;
}

@observer
export class TagSelect extends Component<ITagSelectProps> {
    private availableTagOptions: ITagSets = {};

    public render() {
        const { value, tagKey: key, filter, context, className } = this.props;
        const { [key]: ignore, ...tags } = toLegacyTagsets(filter.tags) || {};
        const combined = combineFilters(
            {
                ...this.props.filter,
                tags,
            },
            context,
        );
        const availableTagOptions =
            metadataStore.tagOptions(combined) || this.availableTagOptions;
        this.availableTagOptions = availableTagOptions;
        const contextTagOptions = metadataStore.tagOptions(context || {}) || {};
        const availableValues = availableTagOptions[key] || [];
        const contextValues = contextTagOptions[key] || [];
        const values = [...new Set([...availableValues, ...value])];

        const options = values.sort().map<IMultiSelectOption<string>>(_ => ({
            value: _,
            icon: "tags",
            label: _ === "" ? "None" : undefined,
            className: _ === "" ? styles.none : undefined,
        }));

        const empty = value.length === 0;

        if (key.startsWith("$.") || (empty && contextValues.length <= 1)) {
            return false;
        }

        const disabled = empty && options.length <= 1;

        return (
            <MultiSelect
                value={value}
                title={key}
                options={options}
                disabled={disabled}
                className={classnames(styles["tag-select"], className)}
                onChange={this.onChange}
            />
        );
    }

    private onChange = (value: string[]) => {
        const { tagKey: key, onChange } = this.props;
        onChange(key, value);
    };
}
